module.exports = __webpack_public_path__ + "img/HERE_logo.ebcce083.png";